var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileUploadSuccess = function SvgFileUploadSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#File_Upload_Success_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8ZM9.13 13.85l-3.25-3.56 1.04-1.14 2.21 2.43 4.95-5.43 1.04 1.14-5.99 6.56Z",
    fill: "#23BD6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "File_Upload_Success_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.5 2)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgFileUploadSuccess;